module.exports = __webpack_public_path__ + "static/img/avartar.be3c558.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avartar.png
// module id = Fl43
// module chunks = 13